import React from 'react';
import PlotCard from '../PlotCard';

const MonthCard = ({
  seriesEnergy,
  seriesPeakPower,
}) => {
  return (
    <PlotCard
      cardTitle={"Last 30 days"}
      cardSubtitle={"Daily energy and peak demand"}
      seriesEnergy={seriesEnergy}
      seriesPeakPower={seriesPeakPower}
      sideBySide
      binMs={24 * 3600 * 1000}
      windowMs={30 * 24 * 3600 * 1000}
      xTickFormat={"%b %d"}
    />
  )
}

export default MonthCard;
